import resources from "./resources.json";
import dssStyles from "./dss.scss?inline";

(function () {
    "use strict";

    var invalidToken = "Invalid/Missing DSS token. Please contact TrustedParts.com.";

    //Internal function: Prepends CSS class names with a common unique-ish tag.
    var prepend = function (cssClass) {
        return "ecia-" + cssClass;
    };
    var dom = {};
    var savedAutoCompleteResults = {};
    var displayedAutocompletePart = null;
    //Internal height var for iframe resizing
    var height = 0;
    var MIN_PARTNUMBER_LENGTH = 2;

    //internal object to represent externally available functions.
    var eds = {};
    //Internal configuration object.
    var config = {};

    //Indicators - status object for various states.
    //Changing an indicator does not automatically update the UI.
    var indicators = {
        //DOM ready event has been called or not.
        ready: false,
        //Init function has been called with necessary configuration data.
        initialized: false,
        //Searching	in progress
        searching: false,
    };

    var t = function (name, ...params) {
        const resource = resources[config.language]?.[name] || name;

        if (!params || !params.length) {
            return resource;
        } else {
            let str = resource;
            for (var i = 0; i < params.length; i++) {
                var reg = new RegExp("\\{" + i + "\\}", "gm");
                str = str.replace(reg, params[i]);
            }

            return str;
        }
    };

    var columnCount = function () {
        var count = 4;
        if (config.showManufacturers) {
            count++;
        }
        if (config.showPricing) {
            count++;
        }
        return count;
    };
    var getLanguageCode = function (cultureCode) {
        if (cultureCode == "zh-Hans" || cultureCode == "zh-Hant") {
            return cultureCode;
        }
        return cultureCode.substring(0, 2);
    };

    //Initialization routine. Copies config data to internal config object with defaulted values.
    var setConfigurationFromAttributes = function () {
        var configData = {};
        configData.root = "trusted-parts-stock-widget-root";
        var rootElement = document.getElementById(configData.root);
        if (!rootElement) {
            throw new Error("Unable to get config from dom node: " + configData.root);
        }
        configData.dssToken = rootElement.getAttribute("data-dss-token");

        if (!configData.dssToken) {
            throw new Error("Configuration is required");
        }
        configData.countryCode = rootElement.getAttribute("data-country-code");
        configData.language = rootElement.getAttribute("data-language");
        configData.currency = rootElement.getAttribute("data-currency");
        configData.partNumber = rootElement.getAttribute("data-part-number");
        configData.showSearch = rootElement.getAttribute("data-show-search");
        configData.searchType = rootElement.getAttribute("data-search-type");
        configData.showPricing = rootElement.getAttribute("data-show-pricing");
        configData.showManufacturers = rootElement.getAttribute("data-show-manufacturers");
        configData.manufacturerId = rootElement.getAttribute("data-manufacturer-id");
        configData.theme = rootElement.getAttribute("data-theme");
        if (!configData.theme) {
            configData.colors = {
                header: rootElement.getAttribute("data-color-header"),
                primary: rootElement.getAttribute("data-color-primary"),
                accent: rootElement.getAttribute("data-color-accent"),
            };
        }

        //required values:
        //root: (string) HTML ID of object to populate with Trusted Parts Widget.
        //dssToken: (string) API Key provided by Trusted Parts to enable data retrieval.
        //optional values:
        //countryCode: (string, default:US) ISO Country code for results.
        //language: (string, default:en-US) Language requested for result data. Note: Not all data will have all languages available.
        //currency: (string, default:USD) Currency requested for result data. Note: Not all data will have all currencies available.
        //partNumber: (string) Optional if showSearch=true, the part number to search.
        //showSearch: (bool) Render search box above results table.
        //searchType: ("exact" or "partial", default "partial") Selects exact part number match or partial part number match for search results.
        //showPricing: (bool, default:true) show pricing data for eligible regions
        //showManufacturers: (bool, default:false) show manufacturer information for result data.
        //theme: (string) Provided theme to use. Options: default, blue, orange, green, blue.
        //colors: (object) - specify your preferred 3 colors as properties: primary (buy/search button, see more link), accent (view button), header. Example: { primary:"orange",accent:"#CC00AF",header:"rgba(0,100,255)" }
        //urlOverride: (string) Override the default search URL (for test/staging).

        config.root = configData.root;
        config.dssToken = configData.dssToken;

        config.countryCode = configData.countryCode || "US";
        config.language = getLanguageCode(configData.language || "en-US");
        config.currency = configData.currency || "USD";

        config.partNumber = configData.partNumber;
        config.showSearch = configData.showSearch === "true" || configData.showSearch === "1";
        config.searchType = configData.searchType === "exact" ? "exact" : "partial";

        config.showPricing = configData.showPricing === "true" || configData.showPricing === "1";
        config.showManufacturers = configData.showManufacturers === "true" || configData.showManufacturers === "1";
        config.manufacturerId = configData.manufacturerId;
        config.theme = configData.theme || "custom";
        if (configData.colors) {
            eds.setCustomColors(configData.colors);
        }
    };
    eds.init = function () {
        indicators.initialized = true;
        ui.initUI();
    };

    //Toggles the UI to show searching row. Note: Locks out the search functionality, call .setNoResults to reset.
    eds.setSearching = function () {
        ui.setSearching();
    };
    //Toggles the UI to show the no-results record;
    eds.setNoResults = function () {
        ui.setNoResults();
    };
    //Sets theme (for instant UI reflection)
    //Blue (default), brown, green, blue2
    eds.setTheme = function (themeName) {
        config.theme = themeName || "default";
        if (dom.root) {
            dom.root.className = css.getThemedClass(prepend("stock-widget"));
        }
    };
    //Sets custom colors (for instant UI customization: see init func for colors contract)
    eds.setCustomColors = function (colors) {
        css.configureCustomTheme(colors);
    };

    //Toggles search on or off. Overrides the .init requirement to show either search box OR provide part number.
    eds.toggleSearch = function (enable) {
        if (!enable && dom.search) {
            dom.search.remove();
            delete dom.search;
        } else if (enable) {
            ui.addSearch();
        }
    };

    eds.postResizeMessage = function () {
        var root = document.getElementById("trusted-parts-stock-widget-root");
        if (root) {
            var newHeight = root.offsetHeight;
            if (height !== newHeight) {
                height = newHeight;
                if (height < 500) height = 500;
                window.parent.postMessage(
                    {
                        frameHeight: height,
                    },
                    "*"
                );
            }
        }
    };

    //Core UI manipulation functions.
    var ui = {
        //Construct the UI. Must be ready & initialized to execute.
        initUI: function () {
            if (indicators.ready !== true || indicators.initialized !== true) return;
            setConfigurationFromAttributes();
            if (dom.root) {
                //remove the root-level item from the actual dom, then clear those params from our in-memory copy.
                dom.root.remove();
                delete dom.root;
                delete dom.tableDiv;
                delete dom.table;
                delete dom.search;
            }

            ui.registerRootDom();
            if (!config.dssToken) {
                ui.addInvalidTokenHeader();
                return;
            }
            if (config.showSearch) {
                ui.addSearch();
            }
            ui.buildResultTable();
            if (config.partNumber) {
                events.executeSearch();
            }

            eds.postResizeMessage();
        },
        //Writes HTML to indicate a missing or invalid API key.
        addInvalidTokenHeader: function () {
            var error = document.createElement("h3");
            error.style.color = "red";
            error.appendChild(document.createTextNode(invalidToken));
            dom.root.innerHTML = "";
            dom.root.appendChild(error);
            eds.postResizeMessage();
        },
        //Registers the root DOM objects in the internal dom object
        registerRootDom: function () {
            dom.base = document.getElementById(config.root);
            if (dom.base === null) {
                throw new Error("Unable to register root dom node: " + config.root);
            }
            dom.root = document.createElement("div");
            dom.root.className = css.getThemedClass(prepend("stock-widget"));
            dom.base.appendChild(dom.root);
            css.registerCssLink();
        },
        //Adds search input and search button to widget.
        addSearch: function () {
            if (dom.search) return;
            var search = document.createElement("div");
            dom.search = search;
            search.className = prepend("widget-search");
            search.appendChild(ui.createTextInput());
            search.appendChild(ui.createSearchButton());
            if (dom.tableDiv) {
                dom.root.insertBefore(search, dom.tableDiv);
            } else {
                dom.root.appendChild(search);
            }
            eds.postResizeMessage();
        },
        //creates search input box
        createTextInput: function () {
            if (dom.search && dom.search.input) return;
            var input = document.createElement("input");
            dom.search.input = input;
            input.type = "text";
            if (config.partNumber && config.partNumber !== "") {
                input.value = config.partNumber;
            }
            input.className = prepend("widget-search-input");
            input.onkeydown = events.searchKeyDown;
            input.onfocus = events.searchFocus;
            //todo: typeahead.
            document.body.addEventListener("click", function (e) {
                if (e.target !== input) {
                    ui.clearAutoComplete();
                }
            });
            return input;
        },
        //create search button and wire events.
        createSearchButton: function () {
            if (dom.search && dom.search.button) return;
            var button = document.createElement("button");
            dom.search.button = button;
            button.className = prepend("widget-search-button");
            button.appendChild(document.createTextNode(t("search")));
            button.onclick = events.executeSearch;
            eds.postResizeMessage();
            return button;
        },
        //Builds search results table.
        buildResultTable: function (resultsWithStock, resultsWithoutStock) {
            ui.buildTableHeader();
            if (resultsWithStock) {
                ui.mergeTableData(resultsWithStock, resultsWithoutStock);
            } else {
                ui.appendFooter();
            }

            eds.postResizeMessage();
        },
        appendFooter: function () {
            var tbl = dom.table;
            var footer = document.createElement("tr");
            footer.className = prepend("footer");
            var poweredByCell = ui.createTextElement("td", t("poweredBy"), prepend("footer-powered-by"));
            var colCount = columnCount();

            var img = document.createElement("img");
            img.src = `${import.meta.env.VITE_CDN_BASE_URL}/assets/images/trusted-parts-logo.svg`;
            img.alt = "TrustedParts.com";
            img.height = "40";
            var logo = document.createElement("a");
            logo.href = import.meta.env.VITE_WEBSITE_URL;
            logo.target = "_blank";
            logo.appendChild(img);

            var tdLogo = document.createElement("td");
            tdLogo.className = prepend("footer-logo");
            tdLogo.appendChild(logo);

            if (colCount > 4) {
                poweredByCell.colSpan = 2;
                tdLogo.colSpan = colCount - 2;
            } else {
                tdLogo.colSpan = colCount - 1;
            }
            footer.appendChild(poweredByCell);
            footer.appendChild(tdLogo);

            tbl.appendChild(footer);
            eds.postResizeMessage();
        },
        //Clears results from the table, skipping the first row (header)
        clearResults: function () {
            //TODO: Optimization? Update table cell contents for rows that exist.
            var tbl = dom.table;
            if (tbl.children.length > 1) {
                for (var i = tbl.children.length - 1; i > 0; i--) {
                    tbl.children[i].remove();
                }
            }

            eds.postResizeMessage();
        },
        mergeTableData: function (resultsWithStock, allDistributors) {
            ui.clearResults();
            if (resultsWithStock && resultsWithStock.length == 0) {
                ui.setNoResults();
                return;
            }
            var tbl = dom.table;
            for (var stockResults = 0; stockResults < resultsWithStock.length; stockResults++) {
                tbl.appendChild(ui.getRow(resultsWithStock[stockResults]));
            }
            if (
                config.manufacturerId &&
                config.manufacturerId !== "0" &&
                allDistributors &&
                allDistributors.length > 0
            ) {
                var tr = document.createElement("tr");
                tr.className = prepend("no-results-distributors-header");
                var td = ui.createTextElement("td", t("includedInSearch"));
                td.colSpan = columnCount();
                tr.appendChild(td);
                tbl.appendChild(tr);
                tr = document.createElement("tr");
                td = document.createElement("td");
                td.colSpan = columnCount();
                td.className = prepend("extra-distributors-span");
                var extraDistribs = [];
                for (var noStockResults = 0; noStockResults < allDistributors.length; noStockResults++) {
                    var alreadyPushed = false;
                    var distributorName = allDistributors[noStockResults].Distributor.name;
                    for (var exD = 0; exD < extraDistribs.length; exD++) {
                        if (extraDistribs[exD] == distributorName) {
                            alreadyPushed = true;
                            break;
                        }
                    }
                    if (!alreadyPushed) {
                        extraDistribs.push(distributorName);
                    }
                }
                extraDistribs.sort();
                for (var ed = 0; ed < extraDistribs.length; ed++) {
                    td.appendChild(ui.createTextElement("span", extraDistribs[ed]));
                }

                tr.appendChild(td);
                tbl.appendChild(tr);
            }
            ui.appendFooter();

            eds.postResizeMessage();
        },
        setSearching: function () {
            ui.clearResults();
            indicators.searching = true;
            var tbl = dom.table;
            var searchingRow = document.createElement("tr");
            var tc = document.createElement("td");
            tc.colSpan = columnCount();
            tc.className = prepend("searching");
            var loaderDiv = document.createElement("div");
            loaderDiv.className = "lds-grid";
            for (var i = 0; i < 9; i++) {
                loaderDiv.appendChild(document.createElement("div"));
            }
            tc.appendChild(loaderDiv);
            tc.appendChild(ui.createTextElement("div", t("searching"), prepend("searching-text")));
            searchingRow.appendChild(tc);
            tbl.appendChild(searchingRow);
            ui.appendFooter();
            ui.clearAutoComplete();

            eds.postResizeMessage();
        },
        setNoResults: function () {
            indicators.searching = false;
            ui.clearResults();
            var tbl = dom.table;
            var noResultRow = document.createElement("tr");
            var tc = ui.createTextElement("td", t("noResults"), prepend("no-results"));
            tc.colSpan = columnCount();
            noResultRow.appendChild(tc);
            tbl.appendChild(noResultRow);
            ui.appendFooter();
            ui.clearAutoComplete();
            eds.postResizeMessage();
        },
        buildTableHeader: function () {
            if (!dom.tableDiv) {
                //If we haven't registered the table element to our in-memory dom yet, we should do that now.
                var tableDiv = document.createElement("div");
                tableDiv.className = prepend("widget-results");
                dom.tableDiv = tableDiv;
                dom.root.appendChild(tableDiv);
                var table = document.createElement("table");
                table.style.cellspacing = 0;
                var colgroup = document.createElement("colgroup");
                for (var i = 1; i <= 6; i++) {
                    //create the column definitions (adjust widths here)
                    //1=Distributor, 2=PartNumber, 3=Manufacturer, 4=Quantity, 5=Pricing, 6=Buy
                    var col = document.createElement("col");
                    if (i === 1) {
                        col.style.minWidth = "150px";
                    } else if (i === 3) {
                        col.style.width = "175px";
                    } else if (i === 4) {
                        col.style.maxWidth = "200px";
                    } else if (i === 5) {
                        col.style.width = "205px";
                    } else if (i === 6) {
                        col.style.width = "115px";
                    }
                    if ((i === 3 && !config.showManufacturers) || (i === 5 && !config.showPricing)) {
                        //Don't add
                    } else {
                        colgroup.appendChild(col);
                    }
                }
                table.appendChild(colgroup);
                //We call it table, but technically it's the tbody
                var tbody = (dom.table = document.createElement("tbody"));
                table.appendChild(tbody);
                table.className = prepend("widget-results-table");
                tableDiv.appendChild(table);
                dom.root.appendChild(tableDiv);
                var tr = document.createElement("tr");
                tr.appendChild(ui.createTextElement("th", t("distributor")));
                tr.appendChild(ui.createTextElement("th", t("partNumber")));
                if (config.showManufacturers) {
                    tr.appendChild(ui.createTextElement("th", t("manufacturer")));
                }
                tr.appendChild(ui.createTextElement("th", t("quantity")));
                if (config.showPricing) {
                    tr.appendChild(ui.createTextElement("th", t("pricing")));
                }
                tr.appendChild(ui.createTextElement("th", ""));
                tbody.appendChild(tr);
                eds.postResizeMessage();
            }
        },
        createTextElement: function (type, text, className) {
            var el = document.createElement(type);
            if (className) {
                el.className = className;
            }
            if (typeof text === "string") {
                var txtArray = text.split(/(?:\r\n|\r|\n|<br ?\/?>)/g);
                if (txtArray.length > 1) {
                    for (var i = 0; i < txtArray.length; i++) {
                        el.appendChild(document.createTextNode(txtArray[i]));
                        if (i < txtArray.length - 1) {
                            el.appendChild(document.createElement("br"));
                        }
                    }
                    return el;
                }
            }

            el.appendChild(document.createTextNode(text));
            eds.postResizeMessage();
            return el;
        },
        getRow: function (data) {
            var row = document.createElement("tr");
            //TODO: distributor logo and url?
            row.appendChild(ui.createTextElement("td", data.Distributor.name, prepend("distributor-cell")));
            row.appendChild(ui.createTextElement("td", data.PartNumber, prepend("partnumber-cell")));

            if (config.showManufacturers) {
                row.appendChild(ui.createTextElement("td", data.Manufacturer, prepend("manufacturer-cell")));
            }
            var stockVal = data.Stock;
            if (stockVal && !isNaN(stockVal) && Number && Number.prototype && Number.prototype.toLocaleString) {
                stockVal = stockVal.toLocaleString();
            }
            var qtyCell = null;

            qtyCell = ui.createTextElement("td", "", prepend("qty-cell"));
            if (data.Stock) {
                qtyCell.appendChild(
                    ui.createTextElement(
                        "div",
                        t("partsInStock", data.Stock.toLocaleString().replace(/\D00$/, "")) +
                            (data.IsDuplicateStock ? "*" : "")
                    )
                );
            }
            if (data.DropShipQuantity) {
                qtyCell.appendChild(
                    ui.createTextElement(
                        "div",
                        t("dropShipQuantity", data.DropShipQuantity.toLocaleString().replace(/\D00$/, ""))
                    )
                );
            }
            if (data.ValueAddQuantity) {
                qtyCell.appendChild(
                    ui.createTextElement(
                        "div",
                        t("valueAddQuantity", data.ValueAddQuantity.toLocaleString().replace(/\D00$/, ""))
                    )
                );
            }
            if (data.OnOrderQuantity) {
                qtyCell.appendChild(
                    ui.createTextElement(
                        "div",
                        t("onOrderQuantity", data.OnOrderQuantity.toLocaleString().replace(/\D00$/, ""))
                    )
                );
            }
            if (data.DisplayFactoryStock && data.FactoryStockQuantity) {
                qtyCell.appendChild(
                    ui.createTextElement(
                        "div",
                        t("factoryStockQuantity", data.FactoryStockQuantity.toLocaleString().replace(/\D00$/, ""))
                    )
                );
            }
            if (data.DisplayFactoryLeadTime) {
                var FactoryLeadTimeIntervalOptions = {
                    DAYS: 0,
                    WEEKS: 1,
                    MONTHS: 2,
                };

                var interval = "";
                if (data.FactoryLeadTime == 1) {
                    switch (data.FactoryLeadTimeInterval) {
                        case FactoryLeadTimeIntervalOptions.DAYS:
                        case "Days":
                            interval = t("leadTimeDay");
                            break;
                        case FactoryLeadTimeIntervalOptions.WEEKS:
                        case "Weeks":
                            interval = t("leadTimeWeek");
                            break;
                        case FactoryLeadTimeIntervalOptions.MONTHS:
                        case "Months":
                            interval = t("leadTimeMonth");
                            break;
                    }
                } else {
                    switch (data.FactoryLeadTimeInterval) {
                        case FactoryLeadTimeIntervalOptions.DAYS:
                        case "Days":
                            interval = t("leadTimeDays");
                            break;
                        case FactoryLeadTimeIntervalOptions.WEEKS:
                        case "Weeks":
                            interval = t("leadTimeWeeks");
                            break;
                        case FactoryLeadTimeIntervalOptions.MONTHS:
                        case "Months":
                            interval = t("leadTimeMonths");
                            break;
                    }
                }

                interval = interval.replace("{0}", data.FactoryLeadTime.toLocaleString().replace(/\D00$/, ""));
                qtyCell.appendChild(ui.createTextElement("div", t("factoryLeadTime", interval)));
            }
            if (data.Stock && data.IsDuplicateStock) {
                var duplicateLabel = document.createElement("div");
                duplicateLabel.setAttribute("class", "pill");
                duplicateLabel.innerHTML =
                    '<span class="pill-label pill-label-default">*' + t("duplicateStock") + "</span>";
                qtyCell.appendChild(duplicateLabel);
            }
            if (
                !data.Stock &&
                !data.DropShipQuantity &&
                !data.ValueAddQuantity &&
                !data.OnOrderQuantity &&
                !(data.DisplayFactoryStock && data.FactoryStockQuantity) &&
                !data.DisplayFactoryLeadTime
            ) {
                qtyCell.appendChild(ui.createTextElement("div", t("outOfStock")));
            }

            row.appendChild(qtyCell);

            if (config.showPricing) {
                var priceCell = ui.buildPriceCell(data.Pricing);
                row.appendChild(priceCell);
            }

            var buyCell = document.createElement("td");
            buyCell.className = prepend("buy-cell");
            if (!data.BuyUrl || data.BuyUrl.length === 0) {
                buyCell.appendChild(document.createTextNode(""));
            } else {
                var btn = ui.createTextElement(
                    "a",
                    data.BuyButtonText,
                    data.IsBuyUrl ? prepend("buy-button") : prepend("view-button")
                );
                btn.target = "_blank";
                btn.href = data.BuyUrl;
                buyCell.appendChild(btn);
            }

            row.appendChild(buyCell);
            return row;
        },
        buildPriceCell: function (pricing) {
            var priceCell = document.createElement("td");
            if (!pricing || pricing.length === 0) {
                priceCell.appendChild(document.createTextNode(""));
                return priceCell;
            }
            if (pricing.length === 1 && !pricing[0].Quantity && !pricing[0].Price) {
                priceCell.appendChild(document.createTextNode(""));
                return priceCell;
            }
            var hideExtras = pricing.length > 5;
            var priceTable = document.createElement("table");
            priceTable.className = prepend("price-table");
            for (var i = 0; i < pricing.length; i++) {
                if (hideExtras && i === 4) {
                    //see more link
                    var trSM = document.createElement("tr");
                    var tdSM = document.createElement("td");
                    tdSM.colSpan = 2;
                    var seeMore = ui.createTextElement("a", t("seeMore"));
                    seeMore.className = prepend("price-more");
                    seeMore.href = "javascript:;";

                    seeMore.onclick = function () {
                        trSM.remove();
                        for (var i = 4; i < priceTable.children.length; i++) {
                            var trHidden = priceTable.children[i];
                            trHidden.style.display = "";
                        }
                        eds.postResizeMessage();
                    };
                    tdSM.appendChild(seeMore);
                    trSM.appendChild(tdSM);
                    priceTable.appendChild(trSM);
                }
                var tr = document.createElement("tr");
                var qtyVal = pricing[i].Quantity;
                if (qtyVal && !isNaN(qtyVal) && Number && Number.prototype && Number.prototype.toLocaleString) {
                    qtyVal = qtyVal.toLocaleString();
                }
                var qty = ui.createTextElement("span", qtyVal);
                qty.className = prepend("price-qty");
                if (hideExtras && i >= 4) {
                    //tag these as hidden
                    tr.style.display = "none";
                }
                var qTD = document.createElement("td");
                qTD.appendChild(qty);
                tr.appendChild(qTD);
                var pTD = document.createElement("td");
                pTD.appendChild(ui.createTextElement("span", pricing[i].Price));
                tr.appendChild(pTD);
                priceTable.appendChild(tr);
            }
            priceCell.appendChild(priceTable);
            return priceCell;
        },
        renderAutoComplete: function (partNumber, results) {
            displayedAutocompletePart = partNumber;
            if (!dom.autocomplete) {
                dom.autocomplete = document.createElement("div");
                dom.autocomplete.className = prepend("autocomplete-results");
                dom.search.appendChild(dom.autocomplete);
            }
            var ac = dom.autocomplete;
            ac.innerHTML = "";
            for (var i = 0; i < results.length; i++) {
                var text = results[i];
                var d = ui.createTextElement("div", text);
                d.onmousedown = function (e) {
                    e.stopPropagation();
                    dom.search.input.value = e.target.textContent || e.target.innerText || e.target.innerHTML;
                    events.executeSearch();
                };
                ac.appendChild(d);
            }
            if (results.length > 0) {
                dom.root.style.minHeight = 82 + 30 * results.length + "px"; //530px is the maximum height necessary for all 15 results.
            } else {
                dom.root.style.minHeight = "auto";
            }

            eds.postResizeMessage();
        },
        clearAutoComplete: function () {
            if (dom.autocomplete) {
                dom.autocomplete.remove();
                delete dom.autocomplete;
            }
            displayedAutocompletePart = null;
            if (dom.root) {
                dom.root.style.minHeight = "auto";
            }
            eds.postResizeMessage();
        },
    };

    //Event functions.
    var events = {
        //Event fired when dom ready browser event is called.
        domReady: function () {
            if (indicators.ready) return;
            indicators.ready = true;
            ui.initUI();
        },
        //Executes search (from search input/button)
        executeSearch: function (e) {
            if (e) {
                e.stopPropagation();
            }
            if (indicators.searching === true) {
                return;
            }
            var searchVal = dom.search ? dom.search.input.value : config.partNumber;
            if (!searchVal || searchVal.length < MIN_PARTNUMBER_LENGTH) {
                return;
            }
            ui.setSearching();
            api.startSearch(searchVal);
        },
        searchKeyDown: function (e) {
            var keyCode = e.which || e.keyCode;
            if (keyCode === 13) {
                e.preventDefault();
                events.executeSearch();
                return;
            }
            setTimeout(function () {
                api.startAutoComplete();
            }, 5);
        },
        searchFocus: function () {
            if (dom.search && dom.search.input) {
                dom.search.input.select();
            }
            setTimeout(function () {
                api.startAutoComplete();
            }, 5); //Show the autocomplete.
        },
        searchComplete: function (data) {
            indicators.searching = false;
            if (
                !data ||
                !data.Data ||
                !data.Data.Result ||
                !data.Data.Result.DistributorResults ||
                data.Data.Result.DistributorResults.length === 0
            ) {
                ui.setNoResults();
                return;
            }
            var withResults = [];
            var noResults = [];
            var distributorResults = data.Data.Result.DistributorResults; //array, objects have properties: Distributor, Ordinal, Products.
            for (var d = 0; d < distributorResults.length; d++) {
                var distributor = distributorResults[d];
                var mappedDistributor = {
                    name: distributor.Distributor.Name,
                };
                if (distributor.Links && distributor.Links.length > 0) {
                    distributor.Links.map(function (link) {
                        if (link.Type === "WebsiteUrl") {
                            mappedDistributor.website = link.Url;
                        } else if (link.TYPE === "Logo") {
                            mappedDistributor.logo = link.Url.replace("~", import.meta.env.VITE_WEBSITE_URL);
                        }
                    });
                }

                noResults.push({
                    Distributor: mappedDistributor,
                });
                if (distributor.Products && distributor.Products.Items && distributor.Products.Items.length > 0) {
                    var products = distributor.Products.Items;
                    for (var p = 0; p < products.length; p++) {
                        var product = products[p];
                        for (var sp = 0; sp < product.SupplierParts.length; sp++) {
                            var supplierPart = product.SupplierParts[sp];
                            var links = {};
                            if (supplierPart.Links && supplierPart.Links.length > 0) {
                                supplierPart.Links.map(function (link) {
                                    if (link.Type == "View") {
                                        links.viewLink = link;
                                    } else if (link.Type == "Buy") {
                                        links.buyLink = link;
                                    }
                                });
                            }
                            var selectedLink = links.buyLink ? links.buyLink : links.viewLink || { Text: "", Url: "" };
                            var pricing = [];
                            if (
                                supplierPart.Pricing &&
                                supplierPart.Pricing.Prices &&
                                supplierPart.Pricing.Prices.length > 0
                            ) {
                                supplierPart.Pricing.Prices.map(function (price) {
                                    pricing.push({ Quantity: price.Quantity, Price: price.FormattedAmount });
                                });
                            }
                            withResults.push({
                                Distributor: mappedDistributor,
                                PartNumber: product.ManufacturerPartNumber,
                                BuyUrl: selectedLink.Url,
                                BuyButtonText: selectedLink.Text,
                                IsBuyUrl: selectedLink.Type == "Buy",
                                Pricing: pricing,
                                Stock:
                                    supplierPart.Stock && supplierPart.Stock.QuantityOnHand
                                        ? supplierPart.Stock.QuantityOnHand
                                        : 0,
                                StockNote:
                                    supplierPart.Stock && supplierPart.Stock.Availability
                                        ? supplierPart.Stock.Availability
                                        : null,
                                DropShipQuantity: supplierPart.DropShipQuantity,
                                ValueAddQuantity: supplierPart.ValueAddQuantity,
                                OnOrderQuantity: supplierPart.OnOrderQuantity,
                                FactoryStockQuantity: supplierPart.FactoryStockQuantity,
                                IsDuplicateStock: supplierPart.IsDuplicateStock,
                                DisplayFactoryStock: supplierPart.DisplayFactoryStock,
                                FactoryLeadTime: supplierPart.FactoryLeadTime,
                                FactoryLeadTimeInterval: supplierPart.FactoryLeadTimeInterval,
                                DisplayFactoryLeadTime: supplierPart.DisplayFactoryLeadTime,
                                SortOrder: supplierPart.SortOrder,
                                IsExactMatch: product.IsExactMatch,
                                Manufacturer: product.Manufacturer ? product.Manufacturer.Name : "",
                            });
                        }
                    }
                }
            }
            withResults.sort(function (a, b) {
                // The server supplied SortOrder does most of the sorting for us,
                // however, we need to group exact matches together at the top
                // Sort by: IsExactMatch, SortOrder
                if (a.IsExactMatch && !b.IsExactMatch) return -1;
                if (b.IsExactMatch && !a.IsExactMatch) return 1;

                if (a.SortOrder < b.SortOrder) return -1;
                if (a.SortOrder > b.SortOrder) return 1;

                return 0;
            });
            ui.buildResultTable(withResults, noResults);
        },
        autoCompleteResults: function (partNumber, data) {
            savedAutoCompleteResults[partNumber] = data;
            if (!data || !data.length || data.length === 0) {
                ui.clearAutoComplete();
                return;
            }

            ui.renderAutoComplete(partNumber, data);
        },
    };
    var api = {
        lastSearch: null,
        startSearch: function (partNumber) {
            if (!partNumber || partNumber.length < MIN_PARTNUMBER_LENGTH) {
                return false;
            }
            var searchQuery = {
                Query: partNumber,
                Type: config.searchType === "exact" ? "ExactPartNumber" : "PartialPartNumber",
            };
            if (config.manufacturerId && config.manufacturerId !== "0") {
                searchQuery.Manufacturer = config.manufacturerId;
            }

            api.lastSearch = partNumber;
            var body = {
                IncludePricing: config.showPricing !== false,
                CurrencyCode: config.currency || "USD",
                CountryCode: config.countryCode || "US",
                Token: config.dssToken,
                CultureCode: config.language || "en",
                Queries: [searchQuery],
            };
            var searchUrl = `${import.meta.env.VITE_API_BASE_URL}/api/dss/query`;

            var request = new XMLHttpRequest();
            request.open("POST", searchUrl, true);
            request.withCredentials = true;
            request.onload = function () {
                if (request.status === 200 || request.status === 400 || request.status === 403) {
                    var resp = JSON.parse(request.responseText);
                    events.searchComplete(resp);
                }
            };
            request.setRequestHeader("Content-Type", "application/json");
            request.setRequestHeader("Accept", "application/json");
            request.send(JSON.stringify(body));
            return true;
        },
        startAutoComplete: function () {
            if (!dom.search || !dom.search.input || !dom.search.input.value) {
                ui.clearAutoComplete();
                return;
            }
            var partNumber = dom.search.input.value;
            if (!partNumber || !partNumber.length || partNumber.length < MIN_PARTNUMBER_LENGTH) {
                ui.clearAutoComplete();
                return;
            }
            if (partNumber === displayedAutocompletePart) {
                return;
            }
            if (partNumber in savedAutoCompleteResults) {
                events.autoCompleteResults(partNumber, savedAutoCompleteResults[partNumber]);
                return;
            }

            var scriptSrc = `${import.meta.env.VITE_API_BASE_URL}/api/partautocomplete?`;
            if (config.manufacturerId && config.manufacturerId !== "0") {
                scriptSrc =
                    scriptSrc + "manufacturerId=" + config.manufacturerId + "&query=" + encodeURIComponent(partNumber);
            } else {
                scriptSrc = scriptSrc + "query=" + encodeURIComponent(partNumber);
            }
            var request = new XMLHttpRequest();
            request.open("GET", scriptSrc, true);
            request.withCredentials = true;
            request.onreadystatechange = function () {
                if (request.readyState >= 4 && request.status === 200) {
                    var data = JSON.parse(request.responseText);
                    events.autoCompleteResults(partNumber, data);
                }
            };
            request.send();
        },
    };

    //CSS and style specific functions.
    var css = {
        registerCssLink: function () {
            if (!dom.head) {
                dom.head = document.getElementsByTagName("HEAD")[0];
            }
            const styles = document.createElement("style");
            styles.innerHTML = dssStyles;
            document.head.appendChild(styles);
        },
        //Gets root level CSS class name including selected theme
        getThemedClass: function (className) {
            if (config.theme && config.theme !== "") {
                return className + " " + prepend("theme-" + config.theme);
            }
            return className;
        },
        //Generates CSS for theme using specified custom colors.
        configureCustomTheme: function (colors) {
            this.registerCssLink();
            if (dom.customCss) {
                dom.customCss.remove();
            }
            var css = (dom.customCss = document.createElement("style"));
            css.type = "text/css";
            var cssStrings = [
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-search button{background:%%BUTTON_COLOR%%;border-color:%%BUTTON_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-search button:active{background:%%ALT_BUTTON_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr.%%PREPEND%%no-results-distributors-header{background:%%HEADER_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr.%%PREPEND%%no-results-distributors-header td{background:%%HEADER_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr:first-child{background:%%HEADER_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr:first-child th{background:%%HEADER_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr>td.%%PREPEND%%buy-cell a{background:%%BUTTON_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%theme-custom .%%PREPEND%%widget-results-table>tbody>tr>td.%%PREPEND%%buy-cell a.%%PREPEND%%view-button{background:%%ALT_BUTTON_COLOR%%}",
                "div#trusted-parts-stock-widget-root .%%PREPEND%%price-table a.%%PREPEND%%price-more{color:%%BUTTON_COLOR%%}",
            ];
            var cssString = cssStrings.join(" ");
            cssString = cssString.replace(/%%PREPEND%%/g, "ecia-");
            cssString = cssString.replace(/%%BUTTON_COLOR%%/g, colors.primary);
            cssString = cssString.replace(/%%ALT_BUTTON_COLOR%%/g, colors.accent);
            cssString = cssString.replace(/%%HEADER_COLOR%%/g, colors.header);
            //TODO: Create css matching colors.
            css.appendChild(document.createTextNode(cssString));
            dom.head.appendChild(css);
            eds.setTheme("custom");
        },
    };

    // Check for dom readiness by just checking for our root dom elm.
    // Waiting for the "DOMContentLoaded" event doesn't work well with iframes, and
    // we don't really care when the whole dome is ready, just when our elm is there.
    var stateCheck = setInterval(function () {
        var root = document.getElementById("trusted-parts-stock-widget-root");
        if (root) {
            clearInterval(stateCheck);
            events.domReady();
            eds.postResizeMessage();
        }
    }, 100);
    eds.config = config;
    eds.init();

    window.onload = function () {
        eds.postResizeMessage();
    };
    window.onresize = function () {
        eds.postResizeMessage();
    };

    window._eds = eds;
})();
